import { Select, SelectProps } from 'antd';
import React, { memo } from 'react';

import { L } from '@lib';

const { Option } = Select;

export const BodyTypeSelect: React.FC<SelectProps> = memo((props) => (
  <Select
    allowClear
    showSearch
    placeholder={L('Select vehicle type')}
    style={{ width: '100%' }}
    {...props}
  >
    <Option value="Commercial">{L('Commercial')}</Option>
    <Option value="Convertible">{L('Convertible')}</Option>
    <Option value="Coupe">{L('Coupe')}</Option>
    <Option value="Estate">{L('Estate')}</Option>
    <Option value="Hatchback">{L('Hatchback')}</Option>
    <Option value="Motorcycle">{L('Motorcycle')}</Option>
    <Option value="MPV">{L('MPV')}</Option>
    <Option value="Saloon">{L('Saloon')}</Option>
    <Option value="SUV">{L('SUV')}</Option>
    <Option value="Other">{L('Other')}</Option>
  </Select>
));
